import { render, staticRenderFns } from "./EducationExamsExamResults.vue?vue&type=template&id=ceb6f408&scoped=true&"
import script from "./EducationExamsExamResults.vue?vue&type=script&lang=js&"
export * from "./EducationExamsExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb6f408",
  null
  
)

export default component.exports